<template>
    <div class="input-group">
        <div class="custom-file custom-file-lang">
            <label class="custom-file-label" :data-lang="$t('components.fileUpload.upload')">
                <span v-if="fileName">{{fileName}}</span>
                <span v-else> {{$t('components.fileUpload.selectFile')}}</span>
                
                <input type="file" class="form-control" @change="selectfile" style="display:none">
            </label>
        </div>
        <div class="input-group-append">
            <b-button variant="primary" @click="ok">{{$t('components.fileUpload.upload')}}</b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fileUpload',
        props: ['url'],
        date: function () {
            return { file: null };
        },
        data: function () {
            return { fileName: null };
        },
        methods: {
            selectfile: function (e) {
                if (e.target && e.target.files) {
                    this.file = e.target.files[0];
                    this.fileName = this.file.name;
                } else {
                    this.file = undefined;
                }
            },
            ok: function () {
                if (this.file) {
                    this.$file({ method: 'post', url: this.url, file: this.file })
                        .then((res) => {
                            this.$emit('ok', { file: this.file, res: res });
                        })
                        .catch((res) => {
                            let msg = res.response.data.Message == null ? "error" : res.response.data.Message;
                            this.$bvToast.toast(msg, { title: '', variant: 'danger', solid: true });
                        });
                }
            },
        }
    };
</script>

<style>
    .custom-file-lang .custom-file-label::after {
        content: attr(data-lang) !important;
        display: none;
    }
</style>